/**
 * @fileoverview Confirm dialog component.
 */

import { sendRequest } from "../../../core/requests";
import { validateConfirm, logValidationErrors } from "../../../core/validation";
import { UI_EVENTS } from "../events";
import type { ConfirmOptions, ConfirmResult } from "../../../core/types";

/**
 * Create the confirm function.
 */
export function createConfirmFunction(): (
  options: ConfirmOptions,
) => Promise<ConfirmResult> {
  return async (options: ConfirmOptions): Promise<ConfirmResult> => {
    const validation = validateConfirm(options);
    if (!validation.valid) {
      logValidationErrors(UI_EVENTS.CONFIRM, validation.errors);
      return Promise.reject(new Error(validation.errors.join(", ")));
    }

    return sendRequest<ConfirmResult>(UI_EVENTS.CONFIRM, {
      title: options.title,
      message: options.message,
      confirmText: options.confirmText ?? "Confirm",
      cancelText: options.cancelText ?? "Cancel",
      variant: options.variant ?? "info",
    });
  };
}
